import { useState } from 'react';
import { Lock } from 'lucide-react';
import { UI } from '../data/portfolio';
import { useLang } from '../i18n';
import { markUnlocked } from '../lib/protected';

export default function ProjectGate({ title, onUnlock }) {
  const { t } = useLang();
  const [value, setValue] = useState('');
  const [error, setError] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (busy || !value) return;
    setBusy(true);
    setError(false);
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/projects/unlock`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password: value }),
      });
      const data = await res.json();
      if (data.ok) {
        markUnlocked();
        onUnlock();
        return;
      }
      setError(true);
    } catch {
      setError(true);
    }
    setBusy(false);
  };

  return (
    <main data-testid="project-gate" className="flex min-h-screen flex-col items-center justify-center px-6 text-center">
      <form onSubmit={submit} className="w-full max-w-xs">
        <Lock size={15} strokeWidth={1.25} data-testid="gate-lock-icon" className="mx-auto text-ink/40" />
        <p className="mt-6 text-[10px] uppercase tracking-[0.3em] text-ink/50">{title}</p>
        <label htmlFor="gate-password" className="mt-14 block text-[10px] uppercase tracking-[0.3em] text-ink/60">
          {t(UI.gatePassword)}
        </label>
        <input
          id="gate-password"
          type="password"
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            setError(false);
          }}
          autoFocus
          data-testid="gate-password-input"
          className="mt-4 w-full border-b border-ink/30 bg-transparent py-3 text-center text-sm tracking-[0.25em] outline-none transition-colors duration-500 focus:border-ink"
        />
        {error && (
          <p data-testid="gate-error" className="mt-4 text-[9px] uppercase tracking-[0.3em] text-ink/70">
            {t(UI.gateError)}
          </p>
        )}
        <button
          type="submit"
          disabled={busy}
          data-testid="gate-submit"
          className="mt-12 border border-ink px-8 py-4 text-[10px] uppercase tracking-[0.3em] transition-colors duration-500 hover:bg-ink hover:text-paper disabled:opacity-40"
        >
          {t(UI.gateEnter)}
        </button>
      </form>
    </main>
  );
}
